export default __webpack_public_path__ + "annotation_layer_builder-d06c74abed96a33c84b7241501f0b602.css";